/* ============================================================
   NB · Live Search
   ------------------------------------------------------------
   Feature 1 · Predictive Suggestions Dropdown
       Fired by every input with [data-nb-search-input].
       Renders Brands / Categories / Pieces sections via
       Shopify's /search/suggest.json API.

   Feature 2 · Auto-Updating Search Results Page
       Inputs additionally tagged [data-nb-search-page]
       fetch the search results section in the background and
       swap the [data-nb-search-results] container in place.
   ============================================================ */
(function () {
  'use strict';

  var DEBOUNCE_MS_SUGGEST = 250;
  var DEBOUNCE_MS_PAGE    = 400;
  var MIN_QUERY_LENGTH    = 2;
  var SUGGEST_LIMIT       = 6;

  /* Category-Handles · alles andere wird als Brand klassifiziert. */
  var CATEGORY_HANDLES = ['tops', 'jackets', 'bottoms', 'footwear', 'accessoires', 'accessories', 'shop-all-accessories'];
  /* Generic / system handles · werden NICHT als Suggestion angezeigt. */
  var EXCLUDED_HANDLES = ['all', 'new-in', 'under-200-chf', 'under-200', 'grails', 'vendors', 'frontpage'];

  /* ============================================================
     Utils
     ============================================================ */
  function escapeHtml(str) {
    if (str == null) return '';
    var div = document.createElement('div');
    div.textContent = String(str);
    return div.innerHTML;
  }

  function formatPriceCHF(priceValue) {
    /* Shopify /search/suggest.json gibt Preise als Dezimalwert in der
       Hauptwährung zurück (z.B. 150 oder "150.00" für CHF 150.00) ·
       NICHT in Cents. Daher KEINE Division durch 100. */
    if (priceValue == null || priceValue === '') return '';
    var amount = typeof priceValue === 'string'
      ? parseFloat(priceValue.replace(/[^0-9.]/g, ''))
      : parseFloat(priceValue);
    if (isNaN(amount)) return '';
    var formatted = amount.toFixed(2);
    var parts = formatted.split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, "'");
    return 'CHF ' + parts.join('.');
  }

  function debounce(fn, wait) {
    var t;
    return function () {
      var ctx = this, args = arguments;
      clearTimeout(t);
      t = setTimeout(function () { fn.apply(ctx, args); }, wait);
    };
  }

  /* ============================================================
     Feature 1 · Predictive Suggestions
     ============================================================ */
  function initPredictiveSearch() {
    var inputs = document.querySelectorAll('[data-nb-search-input]');
    if (!inputs.length) return;

    inputs.forEach(function (input) {
      var wrapper  = input.closest('.nb-search-wrapper');
      if (!wrapper) return;
      var dropdown = wrapper.querySelector('[data-nb-suggestions]');
      if (!dropdown) return;

      var fetchDebounced = debounce(function (query) {
        fetchSuggestions(query, dropdown);
      }, DEBOUNCE_MS_SUGGEST);

      input.addEventListener('input', function () {
        var query = input.value.trim();
        if (query.length < MIN_QUERY_LENGTH) {
          dropdown.hidden = true;
          dropdown.innerHTML = '';
          return;
        }
        dropdown.hidden = false;
        if (!dropdown.innerHTML) {
          dropdown.innerHTML = '<div class="nb-suggestion-loading">Searching…</div>';
        }
        fetchDebounced(query);
      });

      input.addEventListener('focus', function () {
        if (input.value.trim().length >= MIN_QUERY_LENGTH && dropdown.innerHTML) {
          dropdown.hidden = false;
        }
      });

      input.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') {
          dropdown.hidden = true;
          input.blur();
        }
      });

      document.addEventListener('click', function (e) {
        if (!wrapper.contains(e.target)) {
          dropdown.hidden = true;
        }
      });
    });
  }

  function fetchSuggestions(query, dropdown) {
    var url =
      '/search/suggest.json?q=' + encodeURIComponent(query) +
      '&resources[type]=product,collection' +
      '&resources[limit]=' + SUGGEST_LIMIT +
      '&resources[options][unavailable_products]=last';

    fetch(url, { headers: { 'Accept': 'application/json' } })
      .then(function (res) { return res.json(); })
      .then(function (data) { renderSuggestions(data, query, dropdown); })
      .catch(function () {
        dropdown.innerHTML = '<div class="nb-suggestion-empty">Something Went Wrong. Try Again.</div>';
        dropdown.hidden = false;
      });
  }

  function renderSuggestions(data, query, dropdown) {
    var results     = (data && data.resources && data.resources.results) || {};
    var products    = results.products    || [];
    var collections = results.collections || [];

    var brands     = [];
    var categories = [];
    collections.forEach(function (c) {
      if (EXCLUDED_HANDLES.indexOf(c.handle) !== -1) return;
      if (CATEGORY_HANDLES.indexOf(c.handle) !== -1) categories.push(c);
      else brands.push(c);
    });

    var html = '';

    if (brands.length) {
      html += '<div class="nb-suggestion-section">';
      html += '<p class="nb-suggestion-header">Brands</p>';
      brands.forEach(function (b) {
        html += '<a href="' + escapeHtml(b.url || ('/collections/' + b.handle)) + '" class="nb-suggestion-item">';
        html +=   '<div class="nb-suggestion-item-text">';
        html +=     '<p class="nb-suggestion-item-title">' + escapeHtml(b.title) + '</p>';
        html +=   '</div>';
        html += '</a>';
      });
      html += '</div>';
    }

    if (categories.length) {
      html += '<div class="nb-suggestion-section">';
      html += '<p class="nb-suggestion-header">Categories</p>';
      categories.forEach(function (c) {
        html += '<a href="' + escapeHtml(c.url || ('/collections/' + c.handle)) + '" class="nb-suggestion-item">';
        html +=   '<div class="nb-suggestion-item-text">';
        html +=     '<p class="nb-suggestion-item-title">' + escapeHtml(c.title) + '</p>';
        html +=   '</div>';
        html += '</a>';
      });
      html += '</div>';
    }

    if (products.length) {
      html += '<div class="nb-suggestion-section">';
      html += '<p class="nb-suggestion-header">Pieces</p>';
      products.forEach(function (p) {
        var img    = p.image ? p.image : (p.featured_image ? p.featured_image : '');
        var price  = formatPriceCHF(p.price);
        var vendor = p.vendor ? escapeHtml(p.vendor) : '';
        var meta   = vendor ? (vendor + (price ? ' · ' + price : '')) : price;
        html += '<a href="' + escapeHtml(p.url) + '" class="nb-suggestion-item">';
        html +=   '<div class="nb-suggestion-product-img">';
        if (img) {
          html += '<img src="' + escapeHtml(img) + '" alt="' + escapeHtml(p.title) + '" loading="lazy" />';
        }
        html +=   '</div>';
        html +=   '<div class="nb-suggestion-item-text">';
        html +=     '<p class="nb-suggestion-item-title">' + escapeHtml(p.title) + '</p>';
        if (meta) html += '<p class="nb-suggestion-item-meta">' + meta + '</p>';
        html +=   '</div>';
        html += '</a>';
      });
      html += '</div>';
    }

    if (brands.length || categories.length || products.length) {
      html += '<a href="/search?q=' + encodeURIComponent(query) + '" class="nb-suggestion-view-all">View All Results →</a>';
    } else {
      html += '<div class="nb-suggestion-empty">No Pieces Found For &ldquo;' + escapeHtml(query) + '&rdquo;</div>';
    }

    dropdown.innerHTML = html;
    dropdown.hidden = false;
  }

  /* ============================================================
     Feature 2 · Auto-Updating Results on /search
     ============================================================ */
  function initPageAutoUpdate() {
    var pageInputs = document.querySelectorAll('[data-nb-search-page]');
    if (!pageInputs.length) return;

    var resultsContainer = document.querySelector('[data-nb-search-results]');
    if (!resultsContainer) return;

    /* Smooth fade between result swaps */
    if (!document.getElementById('nb-live-search-style')) {
      var style = document.createElement('style');
      style.id = 'nb-live-search-style';
      style.textContent = '[data-nb-search-results]{transition:opacity 200ms ease;}';
      document.head.appendChild(style);
    }

    pageInputs.forEach(function (input) {
      var update = debounce(function (query) {
        updateSearchResults(query, resultsContainer);
        var newUrl = '/search?q=' + encodeURIComponent(query);
        try { history.replaceState({}, '', newUrl); } catch (e) {}
      }, DEBOUNCE_MS_PAGE);

      input.addEventListener('input', function () {
        var query = input.value.trim();
        if (query.length < MIN_QUERY_LENGTH) return;
        update(query);
      });
    });
  }

  function updateSearchResults(query, container) {
    var sectionId = container.getAttribute('data-nb-section-id');
    var url = sectionId
      ? ('/search?q=' + encodeURIComponent(query) + '&section_id=' + encodeURIComponent(sectionId))
      : ('/search?q=' + encodeURIComponent(query));

    container.style.opacity = '0';

    fetch(url, { headers: { 'Accept': 'text/html' } })
      .then(function (res) { return res.text(); })
      .then(function (html) {
        var parser = new DOMParser();
        var doc    = parser.parseFromString(html, 'text/html');

        var newResults = doc.querySelector('[data-nb-search-results]');
        var newTitle   = doc.querySelector('[data-nb-search-title]');
        var newControls = doc.querySelector('[data-nb-search-controls]');
        var titleEl    = document.querySelector('[data-nb-search-title]');
        var controlsEl = document.querySelector('[data-nb-search-controls]');

        if (newResults) container.innerHTML = newResults.innerHTML;
        if (newTitle && titleEl) titleEl.innerHTML = newTitle.innerHTML;
        if (newControls && controlsEl) controlsEl.innerHTML = newControls.innerHTML;

        requestAnimationFrame(function () {
          container.style.opacity = '1';
        });
      })
      .catch(function () {
        container.style.opacity = '1';
      });
  }

  /* ============================================================
     Boot
     ============================================================ */
  function boot() {
    initPredictiveSearch();
    initPageAutoUpdate();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
